module.exports = __webpack_public_path__ + "img/GAME_JANGGI2.1465b09f.jpg";